import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowConfigFlexValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'boolean',
            empty: false,
            mandatory: false
        };
    }
}
